// src/pages/History/EarlyModern/MingQingDynasties.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Early_Modern_Period_-_Ming_and_Qing_Dynasties_China.png';

function HistoryPageMingQingDynasties() {
  return (
    <TopicPage
      topicKey="Ming and Qing Dynasties (China)"
      title="History: Ming and Qing Dynasties"
      backgroundImage={bg}
      startRoute="/History-Ming-Qing-Dynasties-Go"
      scrollLabels={[
        "Ming Maritime Voyages",
        "Qing Expansion and Rule",
        "Confucian Culture and Bureaucracy",
      ]}
      backRoute="/history-early-modern"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageMingQingDynasties;
